/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listEventsForSponsor = () => `
  query ListEventsForSponsor {
    listEventsForSponsor
  }
`;

export const getSponsorLeads = (sponsorCode, nextToken) => {
  if (nextToken) {
    return `
    query MyQuery {
      getSponsorLeads(sponsorCode: "${sponsorCode}", nextToken:"${nextToken}")
    }`;
  } else {
    return `
    query MyQuery {
      getSponsorLeads(sponsorCode: "${sponsorCode}")
    }`;
  }
};

export const getEventDetailsBySponsorCode = (sponsorCode) => `
query MyQuery {
  getEventDetailsBySponsorCode(sponsorCode: "${sponsorCode}")
}`;

export const downloadSponsorLeads = (sponsorCode, eventId) => `
query MyQuery {
  downloadSponsorLeads(eventId: "${eventId}", sponsorCode: "${sponsorCode}")
}`;

export const listSponsorTeam = (eventId, sponsorCode) => `
query MyQuery {
  listSponsorTeam(eventId: "${eventId}", sponsorCode: "${sponsorCode}") {
    items {
      emailId
      imageUrl
      leadsCount
      name
      userId
    }
  }
}`;

// export const getEventDetailsBySponsorCode = /* GraphQL */ `
//   query GetEventDetailsBySponsorCode($sponsorCode: String!) {
//     getEventDetailsBySponsorCode(sponsorCode: $sponsorCode)
//   }
// `;
// export const emailToSponsor = /* GraphQL */ `
//   query EmailToSponsor(
//     $sponsorEmail: String!
//     $sponsorCode: String!
//     $eventName: String!
//     $eventId: String!
//   ) {
//     emailToSponsor(
//       sponsorEmail: $sponsorEmail
//       sponsorCode: $sponsorCode
//       eventName: $eventName
//       eventId: $eventId
//     )
//   }
// `;
// export const listEventsForSponsor = /* GraphQL */ `
//   query ListEventsForSponsor {
//     listEventsForSponsor
//   }
// `;
// export const downloadSponsorLeads = /* GraphQL */ `
//   query DownloadSponsorLeads($sponsorCode: String!, $eventId: String!) {
//     downloadSponsorLeads(sponsorCode: $sponsorCode, eventId: $eventId)
//   }
// `;
// export const getSponsors = /* GraphQL */ `
//   query GetSponsors($sponsorCode: String!) {
//     getSponsors(sponsorCode: $sponsorCode) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const listSponsors = /* GraphQL */ `
//   query ListSponsors(
//     $sponsorCode: String
//     $filter: ModelSponsorsFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//   ) {
//     listSponsors(
//       sponsorCode: $sponsorCode
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//     ) {
//       items {
//         id
//         eventId
//         sponsorName
//         sponsorEmail
//         leadsCount
//         sponsorCode
//         createdBy
//         updatedBy
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const syncSponsors = /* GraphQL */ `
//   query SyncSponsors(
//     $filter: ModelSponsorsFilterInput
//     $limit: Int
//     $nextToken: String
//     $lastSync: AWSTimestamp
//   ) {
//     syncSponsors(
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       lastSync: $lastSync
//     ) {
//       items {
//         id
//         eventId
//         sponsorName
//         sponsorEmail
//         leadsCount
//         sponsorCode
//         createdBy
//         updatedBy
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const getUserSponsorMapping = /* GraphQL */ `
//   query GetUserSponsorMapping($userId: String!, $sponsorCode: String!) {
//     getUserSponsorMapping(userId: $userId, sponsorCode: $sponsorCode) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const listUserSponsorMappings = /* GraphQL */ `
//   query ListUserSponsorMappings(
//     $userId: String
//     $sponsorCode: ModelStringKeyConditionInput
//     $filter: ModelUserSponsorMappingFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//   ) {
//     listUserSponsorMappings(
//       userId: $userId
//       sponsorCode: $sponsorCode
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//     ) {
//       items {
//         id
//         userId
//         eventId
//         leadsCount
//         sponsorCode
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//         owner
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const syncUserSponsorMappings = /* GraphQL */ `
//   query SyncUserSponsorMappings(
//     $filter: ModelUserSponsorMappingFilterInput
//     $limit: Int
//     $nextToken: String
//     $lastSync: AWSTimestamp
//   ) {
//     syncUserSponsorMappings(
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       lastSync: $lastSync
//     ) {
//       items {
//         id
//         userId
//         eventId
//         leadsCount
//         sponsorCode
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//         owner
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const getSponsorAppAuthManagement = /* GraphQL */ `
//   query GetSponsorAppAuthManagement($sponsorKey: String!) {
//     getSponsorAppAuthManagement(sponsorKey: $sponsorKey) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const listSponsorAppAuthManagements = /* GraphQL */ `
//   query ListSponsorAppAuthManagements(
//     $sponsorKey: String
//     $filter: ModelSponsorAppAuthManagementFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//   ) {
//     listSponsorAppAuthManagements(
//       sponsorKey: $sponsorKey
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//     ) {
//       items {
//         id
//         token
//         expiryTime
//         sponsorKey
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const syncSponsorAppAuthManagements = /* GraphQL */ `
//   query SyncSponsorAppAuthManagements(
//     $filter: ModelSponsorAppAuthManagementFilterInput
//     $limit: Int
//     $nextToken: String
//     $lastSync: AWSTimestamp
//   ) {
//     syncSponsorAppAuthManagements(
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       lastSync: $lastSync
//     ) {
//       items {
//         id
//         token
//         expiryTime
//         sponsorKey
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const sponsorsByEventId = /* GraphQL */ `
//   query SponsorsByEventId(
//     $eventId: String!
//     $createdAt: ModelStringKeyConditionInput
//     $sortDirection: ModelSortDirection
//     $filter: ModelSponsorsFilterInput
//     $limit: Int
//     $nextToken: String
//   ) {
//     sponsorsByEventId(
//       eventId: $eventId
//       createdAt: $createdAt
//       sortDirection: $sortDirection
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//     ) {
//       items {
//         id
//         eventId
//         sponsorName
//         sponsorEmail
//         leadsCount
//         sponsorCode
//         createdBy
//         updatedBy
//         createdAt
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const getSponsorLeads = /* GraphQL */ `
//   query GetSponsorLeads($sponsorCode: String!, $bookingId: String!) {
//     getSponsorLeads(sponsorCode: $sponsorCode, bookingId: $bookingId) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const listSponsorLeads = /* GraphQL */ `
//   query ListSponsorLeads(
//     $sponsorCode: String
//     $bookingId: ModelStringKeyConditionInput
//     $filter: ModelSponsorLeadsFilterInput
//     $limit: Int
//     $nextToken: String
//     $sortDirection: ModelSortDirection
//   ) {
//     listSponsorLeads(
//       sponsorCode: $sponsorCode
//       bookingId: $bookingId
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       sortDirection: $sortDirection
//     ) {
//       items {
//         id
//         eventId
//         sponsorCode
//         bookingId
//         name
//         emailId
//         phoneNumber
//         designation
//         organisation
//         comment
//         scannedBy
//         createdAt
//         status
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
// export const syncSponsorLeads = /* GraphQL */ `
//   query SyncSponsorLeads(
//     $filter: ModelSponsorLeadsFilterInput
//     $limit: Int
//     $nextToken: String
//     $lastSync: AWSTimestamp
//   ) {
//     syncSponsorLeads(
//       filter: $filter
//       limit: $limit
//       nextToken: $nextToken
//       lastSync: $lastSync
//     ) {
//       items {
//         id
//         eventId
//         sponsorCode
//         bookingId
//         name
//         emailId
//         phoneNumber
//         designation
//         organisation
//         comment
//         scannedBy
//         createdAt
//         status
//         updatedAt
//         _version
//         _deleted
//         _lastChangedAt
//       }
//       nextToken
//       startedAt
//     }
//   }
// `;
